/* Ravenhall Press — movimiento 3D (libro que se abre y pasa páginas y libro girable).
   Las transiciones entre páginas están en layout/theme.liquid (tienen que cargar antes). */
(function () {
  'use strict';
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function clamp(x, a, b) { return x < a ? a : x > b ? b : x; }
  function ss(a, b, x) { x = clamp((x - a) / (b - a), 0, 1); return x * x * (3 - 2 * x); }

  /* ============ 1 · Libro que se abre y pasa páginas ============ */
  // En móvil y en ordenador funciona igual: se abre y pasa páginas al tocarlo o hacer clic,
  // con los botones de debajo, deslizando o (en ordenador) con las flechas del teclado.
  // El paso entre páginas se anima solo, con la hoja curvándose como el papel. Nunca se queda a medias.
  var track = document.querySelector('[data-rh-open]');
  if (track) (function () {
    var sec = track.closest('.rh-open') || track,
      ob = track.querySelector('[data-rh-ob]'),
      book = ob && ob.querySelector('.rh-ob__book'),
      floor = ob && ob.querySelector('.rh-ob__floor'),
      base = ob && ob.querySelector('.rh-ob__base'),
      leaves = ob ? [].slice.call(ob.querySelectorAll('.rh-ob__leaf')) : [],
      steps = [].slice.call(track.querySelectorAll('.rh-open__steps li')),
      mm = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); },
      touch = mm('(hover: none)') || mm('(pointer: coarse)') || mm('(max-width: 900px)'),
      N = touch ? 6 : 8, LAST = 3, W = 0, D = 0, v = 0, target = 0, mode = '', raf = 0, lastT = 0, papers = [], cover, coverF, coverB;
    if (!book || !leaves.length) return;
    leaves.sort(function (a, b) { return a.getAttribute('data-i') - b.getAttribute('data-i'); });
    cover = leaves[0];
    coverF = cover.querySelector('.rh-ob__face--front');
    coverB = cover.querySelector('.rh-ob__face--back');

    function ease(x) { x = clamp(x, 0, 1); return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }

    // Cada hoja de papel se parte en tiras unidas por bisagras: así puede curvarse al pasar.
    function build() {
      leaves.slice(1).forEach(function (leaf) {
        var f = leaf.querySelector('.rh-ob__face--front > .rh-page'), b = leaf.querySelector('.rh-ob__face--back > .rh-page');
        if (!f || !b) return;
        var rec = { leaf: leaf, h: [], f: [], b: [], ff: f.parentNode, fb: b.parentNode }, parent = leaf;
        for (var j = 0; j < N; j++) {
          var h = document.createElement('div'), sf = document.createElement('div'), sb = document.createElement('div');
          var pf = f.cloneNode(true), pb = b.cloneNode(true);
          h.className = 'rh-ob__hinge';
          sf.className = 'rh-ob__strip';
          sb.className = 'rh-ob__strip rh-ob__strip--back';
          pf.className += ' rh-ob__clone rh-ob__clone--f';
          pb.className += ' rh-ob__clone rh-ob__clone--b';
          sf.appendChild(pf); sb.appendChild(pb); h.appendChild(sf); h.appendChild(sb);
          parent.appendChild(h); parent = h;
          rec.h.push(h); rec.f.push(sf); rec.b.push(sb);
        }
        // En reposo se ve la página entera (sin juntas); las tiras solo aparecen mientras pasa.
        rec.h[0].style.display = 'none';
        leaf.classList.add('is-strips');
        papers.push(rec);
      });
    }
    function measure() {
      W = ob.offsetWidth / 2; D = W * 0.035;
      var s = W / N, e = 2;
      papers.forEach(function (rec) {
        for (var j = 0; j < N; j++) {
          rec.h[j].style.width = s + 'px';
          rec.h[j].style.left = (j ? s : 0) + 'px';
          [rec.f[j], rec.b[j]].forEach(function (st) { st.style.left = (-e / 2) + 'px'; st.style.width = (s + e) + 'px'; });
          var cf = rec.f[j].firstChild, cb = rec.b[j].firstChild;
          cf.style.width = cb.style.width = W + 'px';
          cf.style.left = (-j * s + e / 2) + 'px';
          cb.style.left = (-(N - 1 - j) * s + e / 2) + 'px';
        }
      });
    }

    function setCast(rec, side, c) {
      // Sombra que la hoja que se mueve proyecta sobre la página de debajo (más oscura junto al lomo)
      if (rec) rec.leaf.style.setProperty(side === 'f' ? '--c' : '--cb', c.toFixed(3));
    }

    function render(x) {
      var o = clamp(x, 0, 1), turn = ease(o / 0.55), slide = ease((o - 0.18) / 0.82), n = leaves.length;
      book.style.transform = 'rotateX(' + (4 + 8 * turn).toFixed(2) + 'deg) rotateY(' + (-24 * (1 - turn)).toFixed(2) +
        'deg) translateX(' + (-W / 2 * (1 - slide)).toFixed(1) + 'px)';

      // Tapa (rígida)
      var ca = -180 * slide;
      cover.style.transform = 'translateZ(' + (D + (D / n - D) * slide).toFixed(2) + 'px) rotateY(' + ca.toFixed(2) + 'deg)';
      cover.style.setProperty('--sh', (Math.sin(Math.PI * slide) * 0.35).toFixed(3));
      if (coverF) coverF.style.visibility = ca > -90 ? 'visible' : 'hidden';
      if (coverB) coverB.style.visibility = ca > -90 ? 'hidden' : 'visible';

      // Hojas de papel (se curvan)
      for (var k = 0; k < papers.length; k++) {
        var rec = papers[k], i = k + 1, t = ease(x - i), c = 78 * Math.sin(Math.PI * t), prev = 0;
        var zr = D * (n - i) / n, zl = D * (i + 1) / n, rest = t <= 0 || t >= 1;
        rec.h[0].style.display = rest ? 'none' : '';
        rec.ff.style.display = rec.fb.style.display = rest ? '' : 'none';
        if (rest) {
          rec.leaf.style.transform = 'translateZ(' + (t >= 1 ? zl : zr).toFixed(2) + 'px) rotateY(' + (t >= 1 ? -180 : 0) + 'deg)';
          rec.ff.style.visibility = t >= 1 ? 'hidden' : 'visible';
          rec.fb.style.visibility = t >= 1 ? 'visible' : 'hidden';
          continue;
        }
        rec.leaf.style.transform = 'translateZ(' + (zr + (zl - zr) * t).toFixed(2) + 'px)';
        var As = [];
        for (var j = 0; j < N; j++) As.push(clamp(-180 * t + c * (0.5 - Math.pow(j / (N - 1), 1.5)), -180, 0));
        for (j = 0; j < N; j++) {
          var A = As[j];
          rec.h[j].style.transform = 'rotateY(' + (A - prev).toFixed(2) + 'deg)';
          prev = A;
          var front = A > -90;
          rec.f[j].style.visibility = front ? 'visible' : 'hidden';
          rec.b[j].style.visibility = front ? 'hidden' : 'visible';
          // Sombreado suave a lo largo de la curva: cada tira va del tono de su vecina izquierda al de la derecha
          var sh = function (a) { var cs = Math.cos(a * Math.PI / 180); return a > -90 ? 0.38 * (1 - cs) : 0.38 * (1 + cs); };
          var s0 = (sh(As[Math.max(0, j - 1)]) + sh(A)) / 2, s1 = (sh(A) + sh(As[Math.min(N - 1, j + 1)])) / 2;
          var st = front ? rec.f[j] : rec.b[j];
          st.style.setProperty('--s0', s0.toFixed(3));
          st.style.setProperty('--s1', s1.toFixed(3));
        }
      }

      // Sombras sobre la página de debajo (derecha) y sobre la que recibe la hoja (izquierda)
      var tl = [slide].concat(papers.map(function (r, k) { return ease(x - k - 1); }));
      for (var q = 0; q < papers.length; q++) setCast(papers[q], 'f', Math.sin(Math.PI * tl[q]) * 0.5);
      if (base) base.style.setProperty('--c', (Math.sin(Math.PI * tl[papers.length]) * 0.5).toFixed(3));
      if (coverB) coverB.style.setProperty('--c', (papers[0] ? Math.sin(Math.PI * tl[1]) * 0.45 * tl[1] : 0).toFixed(3));
      for (q = 1; q < papers.length; q++) setCast(papers[q - 1], 'b', Math.sin(Math.PI * tl[q + 1]) * 0.45 * tl[q + 1]);

      if (floor) floor.style.transform = 'scaleX(' + (0.55 + 0.45 * slide).toFixed(3) + ')';
      var lit = (x >= 0.45) + (x >= 1) + (x >= 1.5) + (x >= 2) + (x >= 2.75), cur = lit - 1;
      for (var m = 0; m < steps.length; m++) { steps[m].classList.toggle('is-on', m < lit); steps[m].classList.toggle('is-cur', m === cur); }
      sec.classList.toggle('is-going', target > 0 || x > 0.02);
      sec.classList.toggle('is-closed', target === 0 && x < 0.02);
    }

    function tick(now) {
      raf = 0;
      var dt = lastT ? Math.min(50, now - lastT) : 16;
      lastT = now;
      if (v !== target) {
        var dur = Math.min(v, target) < 1 ? 1500 : 1250; // abrir el libro, un poco más lento que pasar página
        var step = dt / dur * (1 + Math.max(0, Math.abs(target - v) - 1) * 0.9);
        v = v < target ? Math.min(target, v + step) : Math.max(target, v - step);
        render(v);
      }
      if (v !== target) raf = requestAnimationFrame(tick); else lastT = 0;
    }
    function go(tg) {
      target = clamp(tg, 0, LAST);
      sec.classList.toggle('is-going', target > 0 || v > 0.02);
      if (nav) nav.update();
      if (!raf && v !== target) { lastT = 0; raf = requestAnimationFrame(tick); }
    }

    // Se toca o se hace clic en el libro (derecha = siguiente, izquierda = anterior), se desliza o se usan los botones.
    var nav = null;
    function tapMode() {
      mode = 'tap';
      sec.classList.add('is-tap');
      var stage = ob.parentNode, box = document.createElement('div');
      box.className = 'rh-open__nav';
      box.innerHTML = '<button type="button" class="rh-open__btn" data-d="-1" aria-label="Página anterior"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
        '<span class="rh-open__lbl" aria-live="polite"></span>' +
        '<button type="button" class="rh-open__btn" data-d="1" aria-label="Página siguiente"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>';
      stage.appendChild(box);
      var prev = box.querySelector('[data-d="-1"]'), next = box.querySelector('[data-d="1"]'), lbl = box.querySelector('.rh-open__lbl');
      var T = touch
        ? ['Toca el libro para abrirlo', 'Toca la página para pasarla', 'Toca para cerrarlo']
        : ['Haz clic en el libro para abrirlo', 'Haz clic en la página para pasarla', 'Haz clic para cerrarlo'];
      nav = {
        update: function () {
          lbl.textContent = target === 0 ? T[0] : target === LAST ? T[2] : T[1];
          prev.disabled = target === 0;
          next.setAttribute('aria-label', target === LAST ? 'Cerrar el libro' : target === 0 ? 'Abrir el libro' : 'Página siguiente');
        }
      };
      function stepBy(d) {
        sec.classList.add('is-touched');
        if (d > 0 && target === LAST) go(0); else go(target + d);
      }
      prev.addEventListener('click', function () { stepBy(-1); });
      next.addEventListener('click', function () { stepBy(1); });
      var sx = 0, sy = 0, on = false;
      ob.addEventListener('pointerdown', function (e) { if (e.button) return; on = true; sx = e.clientX; sy = e.clientY; });
      ob.addEventListener('pointercancel', function () { on = false; });
      ob.addEventListener('pointerup', function (e) {
        if (!on) return;
        on = false;
        var dx = e.clientX - sx, dy = e.clientY - sy;
        if (Math.abs(dx) > 36 && Math.abs(dx) > Math.abs(dy) * 1.3) { stepBy(dx < 0 ? 1 : -1); return; } // deslizar
        if (Math.abs(dx) > 12 || Math.abs(dy) > 12) return;
        if (target === 0) { stepBy(1); return; }
        var r = ob.getBoundingClientRect();
        stepBy(e.clientX >= r.left + r.width / 2 ? 1 : -1);
      });
      // Ordenador: flechas del teclado cuando el libro está a la vista
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        var a = document.activeElement;
        if (a && (a.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName))) return;
        var r = ob.getBoundingClientRect(), vh = window.innerHeight;
        if (r.bottom < vh * 0.25 || r.top > vh * 0.75) return;
        e.preventDefault();
        if (e.key === 'ArrowRight') { if (target < LAST) stepBy(1); } else if (target > 0) stepBy(-1);
      });
      nav.update();
    }

    build();
    if (reduce) {
      mode = 'static';
      sec.classList.add('is-static');
      measure(); v = target = 2; render(2);
    } else {
      tapMode();
      measure(); v = target = 0; render(0);
    }
    window.addEventListener('resize', function () { measure(); render(v); });
  })();

  /* ============ 2 · Libro girable en la ficha ============ */
  [].forEach.call(document.querySelectorAll('[data-rh-b3d]'), function (el) {
    var obj = el.querySelector('.rh-b3d__obj'), floor = el.querySelector('.rh-b3d__floor');
    if (!obj) return;
    var ctl = el.nextElementSibling && el.nextElementSibling.hasAttribute('data-rh-b3d-ctl') ? el.nextElementSibling : null,
      btns = ctl ? [].slice.call(ctl.querySelectorAll('[data-rh-face]')) : [],
      FACES = { front: -24, spine: 80, back: 156 },
      ry = -24, rx = 6, vy = 0, target = null, drag = false, lx = 0, ly = 0,
      t0 = 0, touched = reduce, visible = true, raf = 0,
      L = [-0.45, 0.89]; // luz desde delante a la izquierda (x, z)

    function lit(nx, nz) { return Math.max(0, nx * L[0] + nz * L[1]); }
    function apply() {
      obj.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
      var r = ry * Math.PI / 180, s = Math.sin(r), c = Math.cos(r);
      // Normales: portada (s, c) · contraportada (-s, -c) · lomo (-c, s) · cantos (c, -s)
      obj.style.setProperty('--sf', (0.6 * (1 - lit(s, c))).toFixed(3));
      obj.style.setProperty('--sb', (0.6 * (1 - lit(-s, -c))).toFixed(3));
      obj.style.setProperty('--ss', (0.6 * (1 - lit(-c, s))).toFixed(3));
      obj.style.setProperty('--se', (0.36 * (1 - lit(c, -s))).toFixed(3));
      if (floor) floor.style.transform = 'scaleX(' + (0.35 + 0.65 * Math.abs(c) + 0.12 * Math.abs(s)).toFixed(3) + ')';
      if (btns.length) {
        var a = ((ry % 360) + 360) % 360, best = '', bd = 46;
        for (var f in FACES) {
          var d = Math.abs(((a - FACES[f]) % 360 + 540) % 360 - 180);
          if (d < bd) { bd = d; best = f; }
        }
        btns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-rh-face') === best)); });
      }
    }

    function loop(now) {
      raf = 0;
      if (drag) return;
      if (!t0) t0 = now;
      var busy = false;
      if (target !== null) {
        var dd = target - ry; ry += dd * 0.13; busy = true;
        if (Math.abs(dd) < 0.15) { ry = target; target = null; }
      } else if (Math.abs(vy) > 0.04) {
        ry += vy; vy *= 0.93; busy = true;
      } else if (!touched) {
        ry = -24 + Math.sin((now - t0) / 1500) * 10; busy = true;
      }
      if (Math.abs(6 - rx) > 0.05) { rx += (6 - rx) * 0.08; busy = true; }
      apply();
      if (busy && visible) raf = requestAnimationFrame(loop);
    }
    function kick() { if (!raf && visible) raf = requestAnimationFrame(loop); }
    function goTo(face) {
      touched = true; vy = 0;
      var a = FACES[face];
      target = a + 360 * Math.round((ry - a) / 360);
      if (reduce) { ry = target; target = null; apply(); return; }
      kick();
    }

    el.addEventListener('pointerdown', function (e) {
      if (e.button) return;
      drag = true; touched = true; target = null; vy = 0; lx = e.clientX; ly = e.clientY;
      el.classList.add('is-drag');
      try { el.setPointerCapture(e.pointerId); } catch (_) { }
    });
    el.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - lx, dy = e.clientY - ly;
      lx = e.clientX; ly = e.clientY;
      ry += dx * 0.5; vy = dx * 0.5;
      rx = clamp(rx - dy * 0.2, -14, 24);
      apply();
    });
    function end() {
      if (!drag) return;
      drag = false; el.classList.remove('is-drag');
      vy = reduce ? 0 : clamp(vy, -16, 16);
      kick();
    }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    el.addEventListener('lostpointercapture', end);
    el.addEventListener('dblclick', function () { goTo('front'); });
    el.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault(); touched = true; vy = 0;
      target = (target !== null ? target : ry) + (e.key === 'ArrowLeft' ? -30 : 30);
      if (reduce) { ry = target; target = null; apply(); } else kick();
    });
    btns.forEach(function (b) { b.addEventListener('click', function () { goTo(b.getAttribute('data-rh-face')); }); });
    if (ctl) ctl.classList.add('is-ready');

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) kick(); }).observe(el);
    }
    apply(); kick();
  });
})();
